import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage from '../../components/LegalPage';

const Datenschutz = () => (
  <LegalPage title="Datenschutzerklärung">
    <p><strong>Stand:</strong> {new Date().getFullYear()}</p>

    <h2>1. Verantwortlicher</h2>
    <p>
      Verantwortlich für die Datenverarbeitung im Tippspiel ist der im{' '}
      <a href="https://tivoli12.at/impressum" target="_blank" rel="noopener noreferrer">Impressum von tivoli12.at</a>
      {' '}genannte Betreiber. Bei Fragen zum Datenschutz wende dich bitte an die dort angegebenen Kontaktdaten.
    </p>

    <h2>2. Welche Daten wir verarbeiten</h2>
    <ul>
      <li><strong>Registrierung:</strong> Benutzername, E-Mail-Adresse, Passwort (gehasht gespeichert)</li>
      <li><strong>Tippspiel:</strong> abgegebene Tipps, Punkte, Statistiken, Spielzuordnungen</li>
      <li><strong>Technisch:</strong> Login-Token (JWT) im lokalen Browser-Speicher, Server-Logdaten</li>
      <li><strong>Cookie-Einstellungen:</strong> deine Auswahl zu optionalen Cookies (lokal gespeichert)</li>
    </ul>

    <h2>3. Zweck &amp; Rechtsgrundlage</h2>
    <ul>
      <li>Bereitstellung des Tippspiels, Authentifizierung und Auswertung (Vertrag / vorvertragliche Maßnahmen, Art. 6 Abs. 1 lit. b DSGVO)</li>
      <li>Sicherheit und Betrieb der Plattform (berechtigtes Interesse, Art. 6 Abs. 1 lit. f DSGVO)</li>
      <li>Optionale Statistik-Cookies nur mit Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)</li>
    </ul>

    <h2>4. Speicherdauer</h2>
    <p>
      Kontodaten und Tipps werden für die Dauer der Saison bzw. des Tippspiels gespeichert. Nach Beendigung
      können Daten anonymisiert oder gelöscht werden, sofern keine gesetzlichen Aufbewahrungspflichten
      entgegenstehen.
    </p>

    <h2>5. Weitergabe an Dritte</h2>
    <p>
      Daten werden nicht verkauft. Eine Weitergabe erfolgt nur an technische Dienstleister (Hosting, Datenbank),
      soweit dies für den Betrieb erforderlich ist, oder wenn wir gesetzlich dazu verpflichtet sind.
      Spiel- und Ergebnisdaten stammen von MFLeague / Vereinsdatenquellen.
    </p>

    <h2>6. Deine Rechte</h2>
    <p>
      Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
      Datenübertragbarkeit und Widerspruch. Beschwerden kannst du bei der österreichischen Datenschutzbehörde einbringen.
    </p>

    <h2>7. Cookies</h2>
    <p>
      Details zu Cookies und lokalen Speichern findest du in den{' '}
      <Link to="/cookie-richtlinien" className="text-primary-light hover:underline">Cookie-Richtlinien</Link>.
    </p>
  </LegalPage>
);

export default Datenschutz;
